<template>
   <el-dialog
      top="1rem"
      class="modal-pre-checkout modal-checkout custom-modal"
      :visible.sync="checkoutModalSuccess"
      :destroy-on-close="true"
      :close-on-press-escape="true"
      :before-close="closeModalRegister"
      :show-close="false"
   >
      <div class="header-modal">
         <h4><i class="el-icon-circle-check mr-1"></i> Solicitação realizada com sucesso!</h4>
      </div>
      <div  class="pl-0 pl-md-4 pr-0 pr-md-4 pb-4">
         <b-card
            no-body
            img-alt="Image"
            img-top
         >
            <!-- Bike info | Informações da bicicleta -->
            <template v-slot:header>
               <b-row align-v="center" class="bike-details">
                  <b-col cols="12" sm="6" class="pl-2 pr-2 pb-0">
                     <img class="img-fluid rounded" :src="getCover(bike.photos.coverPhoto)" alt="">
                  </b-col>
                  <b-col cols="12" sm="6" class="text-center">
                     <h4 style="width: 100%" class="mb-0 ellipsis mt-2 mt-sm-0 mb-1">{{ bike.info.name }}</h4>
                     <span class="text-primary mt-2">Anfitrião: {{
                           successOrder.owner.firstName
                        }} {{ successOrder.owner.lastName }}<small class="d-block"></small></span>
                  </b-col>
               </b-row>
            </template>

            <!-- Information about amounts paid | Informações sobre valores pagos -->
            <b-list-group flush class="text-dark">
               <b-list-group-item>
                  <strong>Modalidade:</strong> {{ handleLeaseModality(successOrder.leaseModality) }} / {{handleTypeOfLease(successOrder.typeOfLeasePeriod)}}
               </b-list-group-item>


               <!-- Por hora -->
               <b-list-group-item v-if="this.typeOfLeasePeriod === 'perHour'">
                  <strong>Dia: </strong>
                  <span class="text-capitalize">{{ successOrder.daySelectedForHourlyRental | moment("utc", 'D[/]MM[/]YYYY [-] dddd') }} | </span>
                  <strong>Tempo de pedalada: </strong>
                  {{ convertDecimalHours(successOrder.pedalingTime) }}
               </b-list-group-item>

               <!-- Por dia -->
               <b-list-group-item v-if="this.typeOfLeasePeriod === 'daily'">
                  <strong>De: </strong>
                  {{ successOrder.period.checkin | moment("utc", 'D[/]MM[/]YYYY') }}
                  <span class="ml-1 mr-1"> | </span>
                  <strong>Até: </strong>
                  {{ successOrder.period.checkout | moment("utc", 'D[/]MM[/]YYYY') }}
               </b-list-group-item>

               <!-- Por semana -->
               <b-list-group-item v-if="this.typeOfLeasePeriod === 'perWeek'">
                  <strong>Quantidade de semanas: </strong>
                  {{ successOrder.numberOfRentalWeeks }}
               </b-list-group-item>

               <!-- Por semana -->
               <b-list-group-item v-if="this.typeOfLeasePeriod === 'monthly'">
                  <strong>Quantidade de meses: </strong>
                  {{ successOrder.numberOfMonthsOfLease }}
               </b-list-group-item>

               <b-list-group-item v-if="isRequestedByOwner">
                  <strong>Ciclista: </strong>
                  <span>{{ successOrder.customer.firstName }} {{successOrder.customer.lastName}}</span>
               </b-list-group-item>

               <b-list-group-item>
                  <strong>Total da Reserva: </strong>
                  <span> {{ successOrder.amount | currency }}</span>
               </b-list-group-item>

               <div class="pl-3 pr-3 d-block d-md-none">
                  <!-- Ultimate Success Button | Sucesso -->
                  <el-button
                     v-if="isRequestedByOwner"
                     class="w-100 text-uppercase font-weight-bold mt-3 mb-3"
                     :round="false"
                     size="small"
                     type="primary"
                     @click="$router.push('/painel/anunciante/pedidos')">Ok, ir para o Painel de Pedidos
                  </el-button>

                  <!-- Ultimate Success Button | Sucesso -->
                  <el-button
                     v-else class="w-100 text-uppercase font-weight-bold mt-3 mb-3"
                     :round="false"
                     size="small"
                     type="primary"
                     @click="$router.push('/painel/ciclista/minhas-reservas')"
                  >
                     Combinar pagamento com o anfitrião
                  </el-button>
               </div>

               <b-list-group-item v-if="isRequestedByOwner" class="bg-secondary">
                  <p><strong>ATENÇÃO:</strong> Lembre-se que você precisa <strong>aprovar</strong> essa <strong>reserva nº
                     #{{ successOrder.orderN }}</strong> no painel de pedidos.</p>
                  <p>Ao clicar no botão "Ok, ir para o Painel de Pedidos" <span class="d-none d-md-inline-block">abaixo</span> <span class="d-inline-block d-md-none">acima</span>, você será direcionado para a seção
                     Pedidos no painel do Anfitrião, e lá você poderá aprovar, cancelar e efetuar checkin/checkout da pedalada.</p>
               </b-list-group-item>

               <b-list-group-item v-else class="bg-secondary">
                  <p><strong>ATENÇÃO:</strong> Combine com o anfitrião sobre o pagamento desta <strong>Reserva nº
                     #{{ successOrder.orderN }}</strong>.</p>
                  <p>Ao clicar no botão "Combinar com o Anfitrião" <span class="d-none d-md-inline-block">abaixo</span> <span class="d-inline-block d-md-none">acima</span>, você será direcionado para o painel de pedidos, aonde você poderá falar com o anunciante via chat.</p>
               </b-list-group-item>
            </b-list-group>
         </b-card>

       <div class="pl-3 pr-3 d-none d-md-block">
          <!-- Ultimate Success Button | Sucesso -->
          <el-button
             v-if="isRequestedByOwner"
             class="w-100 text-uppercase font-weight-bold mt-4"
             :round="true"
             size="small"
             type="primary"
             @click="$router.push('/painel/anunciante/pedidos')">Ok, ir para o Painel de Pedidos
          </el-button>

          <!-- Ultimate Success Button | Sucesso -->
          <el-button
             v-else class="w-100 text-uppercase font-weight-bold mt-4"
             :round="true"
             size="small"
             type="primary"
             @click="$router.push('/painel/ciclista/minhas-reservas')"
          >
             Ok, Combinar com o anfitrião
          </el-button>
       </div>

      </div>

   </el-dialog>
</template>

<script>
import BikeImg from "@/helpers/GetBikeCover";
import { BListGroup, BListGroupItem, BCard } from 'bootstrap-vue'
import {handleLeaseModality, handleTypeOfLease, convertDecimalHoursToHM} from "../../helpers";
export default {
   name: 'CheckoutModalSuccess',
   props: {
      checkoutModalSuccess: Boolean,
      isRequestedByOwner: Boolean,
      bike: {
         name: String,
         cover: String
      },
      successOrder: {
         orderN: String,
         owner: {
            firstName: String,
            lastName: String
         },
         user: {
            avatar: {

            }
         },
         period: {
            checkin: null,
            checkout: null
         }
      },
      loggedInUserInformation: {
         firstName: String,
         lastName: String
      },
      typeOfLeasePeriod: String,
      leaseModality: String,
   },
   components: { BListGroup, BListGroupItem, BCard},
   directives: {
      'b-list-group': BListGroup,
      'b-list-group-item': BListGroupItem,
      'b-card': BCard
   },
   data() {
      return {
         baseUrl: process.env.VUE_APP_BASE_URL,
         apiV1: process.env.VUE_APP_API_V1,
      }
   },
   methods: {
      handleTypeOfLease,
      handleLeaseModality,
      getCover(uri) {
         return BikeImg.getCover(uri);
      },
      closeModalRegister() {

      },
      convertDecimalHours(time) {
         return convertDecimalHoursToHM(time)
      }
   },
}
</script>

<style lang="scss" scoped>

</style>
